import { render, staticRenderFns } from "./RecommendedThresholdForm.vue?vue&type=template&id=e3dbad4e&scoped=true"
import script from "./RecommendedThresholdForm.vue?vue&type=script&lang=ts"
export * from "./RecommendedThresholdForm.vue?vue&type=script&lang=ts"
import style0 from "./RecommendedThresholdForm.vue?vue&type=style&index=0&id=e3dbad4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dbad4e",
  null
  
)

export default component.exports